import { SHIPPED_CLIPS } from '@/data/media';
import type { ShippedClip } from '@/types';

/**
 * The clip a gallery post can play inline, or `null` to keep the post a link.
 *
 * Only clips that ship with the site qualify. Visitor-supplied urls point at
 * pages rather than at video files, so feeding one to a `<video>` element would
 * fail with nothing on screen to explain it — and would pull a third-party
 * request into a page that otherwise makes none.
 */
export function inlineVideo(url: string): ShippedClip | null {
  // `hasOwn` rather than a plain lookup: `url` is visitor-supplied, and
  // 'constructor' would otherwise come back as a truthy inherited property.
  return Object.hasOwn(SHIPPED_CLIPS, url) ? (SHIPPED_CLIPS[url] ?? null) : null;
}
